module.exports = __webpack_public_path__ + "static/media/terrace-7.b63d3687.jpg";